module.exports = __webpack_public_path__ + "img/Biplab.211fa747.jpg";